module.exports = __webpack_public_path__ + "static/img/14002017.9381d1be.png";